import { usePaginatedPosts } from './usePaginatedPosts';

export interface UseMainPostId {
    tokenName: string;
    flairId?: string;
}

export const useMainPostId = (payload: UseMainPostId) => {
    const { tokenName, flairId } = payload;
    const { postIds } = usePaginatedPosts({ type: 'partner', tokenName, flairId, fetchLimit: 12 });
    const { postIds: pinnedPostsIds } = usePaginatedPosts({ type: 'pinned', tokenName });

    const combinedPosts = flairId ? postIds : Array.from(new Set([...pinnedPostsIds, ...postIds]));
    return combinedPosts[0];
};
